//获取待申请列表
export const GET_PENDING_LISTS = "GET_PENDING_LISTS";
//设置待申请列表
// export const SET_PENDING_LISTS = "SET_PENDING_LISTS";

//获取已生效列表
export const GET_EFFECTIVE_LISTS = "GET_EFFECTIVE_LISTS";
//设置已生效列表
// export const SET_EFFECTIVE_LISTS = "SET_EFFECTIVE_LISTS";

//获取已申请/已拒绝列表
export const GET_APPLY_REFUSE_LISTS = "GET_APPLY_REFUSE_LISTS";
//设置已申请/已拒绝列表
// export const SET_APPLY_REFUSE_LISTS = "SET_APPLY_REFUSE_LISTS";


//提交发票
export const APPLY_INVOICE = "APPLY_INVOICE";

//取消发票
export const CANCEL_INVOICE = "CANCEL_INVOICE";

//获取发票信息
export const GET_INVOICE_INFO = "GET_INVOICE_INFO";
//设置发票信息
export const SET_INVOICE_INFO = "SET_INVOICE_INFO";

//获取物流
export const CHECK_LOGISTICS = "CHECK_LOGISTICS";
//设置物流
export const SET_LOGISTICS = "SET_LOGISTICS";

//获取申请单详情
export const GET_INVOICE_APPLY_DETAIL = "GET_INVOICE_APPLY_DETAIL";
//设置申请单详情
export const SET_INVOICE_APPLY_DETAIL = "SET_INVOICE_APPLY_DETAIL";










// WEBPACK FOOTER //
// ./src/store/invoice-manage/type.js